import { create } from 'zustand';
import { ApiUtils, ApplicationApi, type ManualApplicationEntity, type ManualApplicationSearchParams, RequestStrategyEnum } from '@shared/api';

interface UseSearchManualApplicationsStore {
  loading: boolean;
  data: ManualApplicationEntity[];
  error: string | null;
  searchManualApplications: (request?: ManualApplicationSearchParams, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useSearchManualApplicationsStore = create<UseSearchManualApplicationsStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  searchManualApplications: ApiUtils.wrapperApi(async (request = {}, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await ApplicationApi.searchManualApplications(request, signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
